export const EmptyVisitDatesOptions = [
  {
    value: '08/04/2025',
    label: '08-04-2025',
    id: '2025-04-08T00:00:00+02:00',
  },
  {
    value: '09/04/2025',
    label: '09-04-2025',
    id: '2025-04-09T00:00:00+02:00',
  },
  {
    value: '10/04/2025',
    label: '10-04-2025',
    id: '2025-04-10T00:00:00+02:00',
  },
  {
    value: '11/04/2025',
    label: '11-04-2025',
    id: '2025-04-11T00:00:00+02:00',
  },
  {
    value: '12/04/2025',
    label: '12-04-2025',
    id: '2025-04-12T00:00:00+02:00',
  },
  {
    value: '13/04/2025',
    label: '13-04-2025',
    id: '2025-04-13T00:00:00+02:00',
  },
];
